import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Leaderboard.css';
import Countdown from 'react-countdown-now';
import { padNumber, fromIso9075DateString } from 'utils/functions';
import Ranking from '../Ranking/index';
import RewardIcon from '../RewardIcon';
import { REWARD_TYPE } from 'utils/rewards';
import { userShape } from 'utils/shapes';
import ScalingTextBlock from 'components/ScalingTextBlock';
import moment from 'moment';

const REWARD_TYPES = {
  Accommodation: REWARD_TYPE.HOTEL_STAY,
  Concert: REWARD_TYPE.DEFAULT,
  Contests: REWARD_TYPE.DEFAULT,
  Cooking: REWARD_TYPE.FOOD_CREDIT,
  Center: REWARD_TYPE.DEFAULT,
  Essentials: REWARD_TYPE.DEFAULT,
  Events: REWARD_TYPE.DEFAULT,
  'Free Play': REWARD_TYPE.SHOPPING_DOLLARS,
  Restaurant: REWARD_TYPE.FOOD_CREDIT,
  Spa: REWARD_TYPE.DEFAULT
};

const renderer = ({ days, hours, minutes, seconds }) => {
  return (
    <div>
      <p>Time Remaining:</p>
      <p>
        {days ? padNumber(days) + ':' : ''}
        {days || hours ? padNumber(hours) + ':' : ''}
        {padNumber(minutes)}:{padNumber(seconds)}
      </p>
    </div>
  );
};

class Leaderboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      browserMillis: 0
    };
  }

  componentWillReceiveProps(nextProps) {
    const { tournament } = nextProps;
    const { browserMillis } = this.state;

    if (tournament && browserMillis === 0) {
      this.setState({
        browserMillis: moment().valueOf()
      });
    }
  }

  render() {
    const {
      tournament,
      userScore,
      user,
      ranks,
      onCountdownComplete
    } = this.props;
    const { browserMillis } = this.state;

    const lRanks = ranks.slice(0);

    lRanks.sort((a, b) => {
      return a.rank === b.rank ? 0 : a.rank < b.rank ? -1 : 1;
    });

    const numPlayers = userScore ? userScore.totalRank.split('/')[1].trim() : 0;

    const tournamentMillis = tournament
      ? moment.utc(tournament.endTime).valueOf()
      : moment().valueOf();
    const serverMillis = tournament
      ? parseInt(tournament.serverTime, 10)
      : moment().valueOf();

    const countdown = tournamentMillis - serverMillis + browserMillis;

    return (
      <div className="leaderboard">
        <div className="header clearfix">
          <div className="prize">
            <div className="body clearfix">
              <div className="title">Prize</div>
              <ScalingTextBlock cssClass="message" maxHeight="3em">
                {tournament && tournament.description}
              </ScalingTextBlock>
            </div>
          </div>
          <div className="stats">
            <div className="players">{`${numPlayers} players`}</div>
            <div className="timer">
              <Countdown
                date={countdown}
                renderer={renderer}
                onComplete={onCountdownComplete}
              />
            </div>
          </div>
        </div>
        <div className="rankings">
          {lRanks.map((element, i) => {
            return <Ranking key={i} {...element} type="" />;
          })}
        </div>
        <Ranking
          id={0}
          type="user"
          rank={userScore.rank}
          player={user}
          score={userScore.score}
        />
      </div>
    );
  }
}

Leaderboard.propTypes = {
  tournament: PropTypes.object,
  userScore: PropTypes.shape({
    score: PropTypes.number,
    rank: PropTypes.number
  }),
  user: userShape,
  ranks: PropTypes.arrayOf(
    PropTypes.shape({
      player: userShape,
      rank: PropTypes.number,
      score: PropTypes.number
    })
  ),
  onCountdownComplete: PropTypes.func
};

export default Leaderboard;



// WEBPACK FOOTER //
// ./src/components/Leaderboard/index.js